// extracted by mini-css-extract-plugin
export default {"post":"PostCard_post__SGRUY","capa":"PostCard_capa__j1JIb","titulo":"PostCard_titulo__Wl7cV"};